const actions = {
  SET_EDIT_LISTING_DATA: "SET_EDIT_LISTING_DATA",
  SET_CATEGORY_FIELDS: "SET_CATEGORY_FIELDS",
  RESET_LISTING_DATA: "RESET_LISTING_DATA",
  CLEAR_EDIT_LISTING_DATA: "CLEAR_EDIT_LISTING_DATA",
  SET_UPDATED_LISTING_DATA: "SET_UPDATED_LISTING_DATA",
  setEditListingData: (payload) => {
    return {
      type: actions.SET_EDIT_LISTING_DATA,
      payload,
    };
  },
  setCategoryFields: (payload) => {
    return {
      type: actions.SET_CATEGORY_FIELDS,
      payload,
    };
  },
  setUpdatedListingData: (payload) => {
    return {
      type: actions.SET_UPDATED_LISTING_DATA,
      payload,
    };
  },
  resetListingData: (payload) => {
    return {
      type: actions.RESET_LISTING_DATA,
      payload,
    };
  },
  clearEditListingData: () => {
    return {
      type: actions.CLEAR_EDIT_LISTING_DATA,
    };
  },
};

export default actions;
